<div class="payment-rounds-tab">
  <form
    [formGroup]="monthFilterForm"
    class="form-b4a payment-rounds-filter-form"
    (submit)="applyMonthFilter()"
  >
    <span class="p-float-label payment-rounds-filter-form__month">
      <p-calendar
        inputId="paymentRoundsMonth"
        formControlName="month"
        view="month"
        dateFormat="mm/yy"
        [showIcon]="true"
      />
      <label for="paymentRoundsMonth">Mes de referencia *</label>
    </span>

    <div class="payment-rounds-filter-form__actions">
      <p-button
        icon="pi pi-chevron-left"
        type="button"
        severity="secondary"
        [outlined]="true"
        (onClick)="goToPreviousMonth()"
      />
      <p-button
        icon="pi pi-chevron-right"
        type="button"
        severity="secondary"
        [outlined]="true"
        (onClick)="goToNextMonth()"
      />
      <p-button
        label="Aplicar"
        icon="pi pi-search"
        type="submit"
        [disabled]="monthFilterForm.invalid"
      />
    </div>
  </form>

  <p class="payment-rounds-tab__subtitle" *ngIf="selectedMonthLabel">
    Rodadas de cobranca de {{ selectedMonthLabel }}
  </p>

  <app-table
    *ngIf="paymentRounds.length > 0"
    [lazy]="false"
    [elements]="paymentRounds"
    [cols]="paymentRoundCols"
    [actionButtons]="paymentRoundActions"
    [addButton]="false"
    [exportExcel]="false"
    [exportPdf]="false"
    [showTitle]="false"
    modelName="rodadas de cobranca"
    sortField="status"
    [sortOrder]="1"
  />

  <div class="config-warning" *ngIf="paymentRounds.length === 0">
    Nenhuma rodada de cobranca encontrada para o mes selecionado.
  </div>
</div>
